<template>
    <v-container class="fill-height">
        <v-row align="center" justify="center">
            <v-col cols="2" offset="1" class="text-caption" v-if="mdAndUp">
                <p> <br />
                    Por que perder a esperança <br />
                    De nos tornar a ver? <br />
                    Por que perder a esperança <br />
                    Se há tanto querer? <br />
                </p> <br />
                <p> <br />
                    Não é mais que um até logo <br />
                    Não é mais que um breve adeus <br />
                    Bem cedo junto ao fogo <br />
                    Tornaremos a nos ver <br />
                </p> <br />
                <p> <br />
                    Com nossas mãos entrelaçadas <br />
                    Ao redor do calor <br />
                    Formemos esta noite <br />
                    Um círculo de amor <br />
                </p> <br />
                <p> <br />
                    Não é mais que um até logo <br />
                    Não é mais que um breve adeus <br />
                    Bem cedo junto ao fogo <br />
                    Tornaremos a nos ver <br />
                </p> <br />
                <p> <br />
                    Pois o Senhor que nos protege <br />
                    E nos vai abençoar <br />
                    Um dia certamente <br />
                    Vai de novo nos juntar <br />
                </p> <br />
                <p> <br />
                    Não é mais que um até logo <br />
                    Não é mais que um breve adeus <br />
                    Bem cedo junto ao fogo <br />
                    Tornaremos a nos ver <br />
                </p> <br />
            </v-col>
            <v-col cols="7" class="text-center" v-if="!removed">
                Confirmar remoção?
                <br />
                <v-btn @click="removeNotificationFone" :disabled="requestingApi">
                    Remover
                </v-btn>
            </v-col>
            <v-col cols="7" class="text-center" v-else>
                Número Removido!
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import assets from "../assets/assets";
import { useDisplay } from 'vuetify';
import api from '@/services'
export default {
     setup() {
        // Destructure only the keys we want to use
        const { mdAndUp } = useDisplay();

        return { mdAndUp }
    },
    activated() {
        const vm = this;
        const urlParams = new URLSearchParams(window.location.search);

        vm.phoneNumber = urlParams.get('t');
    },
    data() {
        return {
            requestingApi: false,
            phoneNumber: '',
            removed: false,
            assets: assets,
        };
    },
    methods: {
        removeNotificationFone() {
            const vm = this;

            console.log(vm.phoneNumber);
            if (!vm.requestingApi) {
                vm.requestingApi = true;
                api.legalPerson.removeNotification(vm.phoneNumber).then((result) => {
                    console.log(result);
                    vm.removed = true;
                }).catch((err) => {
                    if (err.message) {
                        vm.$notify({
                            type: "warn",
                            text: err.message,
                        });
                    }
                }).finally(() => {
                    vm.requestingApi = false;
                });
            }
        }
    }
};
</script>